const subs = {};

export const subscribe = (key, func) => {
    if (typeof subs[key] !== "undefined") {
        subs[key].push(func);
    } else {
        subs[key] = [func];
    }
};
window.subscribe = subscribe;

export const publish = (key, ...params) => {
    const s = (subs[key] || []);
    const l = s.length;
    for (let i = 0; i < l; i++) {
        s[i](...params);
    }
}
window.publish = publish;